module.exports = __webpack_public_path__ + "static/media/LeagueSpartan-Bold.9a223d8a.ttf";